import { z } from "zod";
import { ClientId, DateSchema, FartherAccountId, PortfolioPlanAssignmentId, TaskId, } from "../Types";
export const LiquidationStatus = z.enum(["PENDING", "COMPLETED"]);
export const Amount = z.string().refine((value) => {
    const numberValue = parseFloat(value);
    return !isNaN(numberValue) && numberValue > 0;
}, {
    message: "Input must be a positive number in string format",
});
export const RaiseCashRequestId = z.string().brand("RaiseCashRequestId");
const RaiseCashStatus = z.enum([
    "Initiated",
    "PendingLiquidationProposalApproval",
    "PendingLiquidationTaskCompletion",
    "Complete",
    "Canceled",
    "Error",
]);
export const ResponseBase = z.object({
    taskId: TaskId,
    clientId: ClientId,
    concreteImplementationPlanId: PortfolioPlanAssignmentId,
    accountId: FartherAccountId,
    amount: z.string().nullable(),
    isFullLiquidation: z.boolean(),
    status: RaiseCashStatus,
});
export const RaiseCashRequestResponse = ResponseBase.extend({
    raiseCashId: RaiseCashRequestId,
    reason: z.string().nullable(),
    createdAt: DateSchema,
    updatedAt: DateSchema,
});
export const UpdateRaiseCashRequestBody = z.object({
    status: RaiseCashStatus.extract([
        "PendingLiquidationProposalApproval",
        "PendingLiquidationTaskCompletion",
    ]),
});
export const CompleteOrCancelRaiseCashRequestBody = z.object({
    status: RaiseCashStatus.extract(["Complete", "Canceled"]),
    taskId: TaskId,
});
export const PutRequestBody = z.union([
    UpdateRaiseCashRequestBody,
    CompleteOrCancelRaiseCashRequestBody,
]);
//# sourceMappingURL=Types.js.map